import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DragContextType {
    isDragging: boolean;
    setIsDragging: (dragging: boolean) => void;
}

const DragContext = createContext<DragContextType | undefined>(undefined);

export const useDrag = (): DragContextType => {
    const context = useContext(DragContext);
    if (context === undefined) {
        throw new Error('useDrag must be used within a DragProvider');
    }
    return context;
};

interface DragProviderProps {
    children: ReactNode;
}

export const DragProvider: React.FC<DragProviderProps> = ({ children }) => {
    const [isDragging, setIsDragging] = useState(false);

    const value: DragContextType = {
        isDragging,
        setIsDragging,
    };

    return (
        <DragContext.Provider value={value}>
            {children}
        </DragContext.Provider>
    );
};

export default DragProvider;

